import React from "react";
import { AlertTriangle, CheckCircle2, Clock, XCircle } from "lucide-react";

export const ADMIN_DKIM_URL = "https://admin.google.com/ac/apps/gmail/authenticateemail";

export function Guard({ children, testid }) {
  return (
    <div data-testid={testid} className="border border-amber-500/30 bg-amber-500/5 text-amber-300 rounded-sm p-4 text-sm">
      <div className="flex items-start gap-3"><AlertTriangle size={16} className="mt-0.5 shrink-0" /><div className="text-xs leading-relaxed opacity-90">{children}</div></div>
    </div>
  );
}

export function DkimField({ value, onChange, optional }) {
  return (
    <label className="block">
      <div className="label-tiny mb-1.5">DKIM TXT value {optional && <span className="text-zinc-600 normal-case tracking-normal">(optional now — can be pasted later)</span>}</div>
      <textarea
        data-testid="gws-dkim-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={2}
        placeholder="v=DKIM1; k=rsa; p=MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A…"
        className="w-full bg-zinc-950 border border-zinc-800 rounded-sm px-3 py-2 text-xs mono outline-none"
      />
    </label>
  );
}

export function StateBadge({ ok, label }) {
  if (ok) return <span className="inline-flex items-center gap-1 text-[11px] text-emerald-400 mono"><CheckCircle2 size={11} /> {label}</span>;
  if (label === "missing" || label === "mismatch") return <span className="inline-flex items-center gap-1 text-[11px] text-red-400 mono"><XCircle size={11} /> {label}</span>;
  return <span className="inline-flex items-center gap-1 text-[11px] text-amber-400 mono"><Clock size={11} /> {label}</span>;
}
